import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1;
    background: rgb(248, 250, 252);
  }
  ol, ul, li {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font: 400 16px Raleway, sans-serif;

  }
  body {
    background: ${(props) => props.theme?.colors?.background};
    color: ${(props) => props.theme?.colors?.textPrimary};
    font: 400 16px Raleway, sans-serif;
  }

  .number {
    font-family: 'Work Sans', sans-serif!important;
  }

  button {
    border: 0px solid transparent;
    background: transparent;
    border-radius: 0;
    cursor: pointer;

    &:focus{
      outline: thin dotted;
      outline: 0px auto -webkit-focus-ring-color;
      outline-offset: 0px;
    }

    &:focus {
      outline: thin dotted;
      outline: 0px auto -webkit-focus-ring-color;
      outline-offset: 0px;
    }
  }

  @media (max-width: 1720px) {
    html {
      font-size: 94.79%!important;
    }
  }

  @media (max-width: 1620px) {
    html {
      font-size: 89.58%!important;
    }
  }

  @media (max-width: 1520px) {
    html {
      font-size: 84.38%!important;
    }
  }

  @media (max-width: 1420px) {
    html {
      font-size: 79.17%!important;
    }
  }

  @media (max-width: 992px) {
    html {
      font-size: 73.96%!important;
    }
  }


  @media (max-width: 1312px) {
    html {
      font-size: 68.33%!important;
    }
  }


  @media (max-width: 688px) {
    html {
      font-size: 70%!important;
    }
  }

  @keyframes shimmer {
    100% {
      -webkit-mask-position: left;
    }
  }


@media print {
   .no-print{
       display:none;
   }
}

`;
